import { render } from "./ItemComponent.vue?vue&type=template&id=3b8d7cde&scoped=true"
import script from "./ItemComponent.vue?vue&type=script&lang=js"
export * from "./ItemComponent.vue?vue&type=script&lang=js"

import "./ItemComponent.vue?vue&type=style&index=0&id=3b8d7cde&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b8d7cde"]])

export default __exports__